import { drilldownDataCorporate, ModuleFields } from "~/Utils/drilldownDataDum";

export const mapFields = (data: ModuleFields[]) => {
  return data.map(({ fieldName, placeholder, name, formType, validation, className, hidden,usedFileType, options }) => ({
    name,
    type: formType,
    label: fieldName,
    placeholder,
    validation,
    className,
    hidden,
    usedFileType,
    options
  }));
};

let fields: any = {};

const fieldsReady = new Promise(async (resolve, reject) => {
  try {
    const data = await drilldownDataCorporate();
    fields = {
      managementTeamPageContent: mapFields(data?.managementTeamPageContent),
      companyStructurePageContent: mapFields(data?.companyStructurePageContent),
      boardOfDirectorsPageContent: mapFields(data?.boardOfDirectorsPageContent),
      managementTeamPageHeading: mapFields(data?.managementTeamPageHeading),
      companyStructurePageHeading: mapFields(data?.companyStructurePageHeading),
      boardOfDirectorsPageHeading: mapFields(data?.boardOfDirectorsPageHeading),
      boardOfDirectorsNextPage: mapFields(data?.boardOfDirectorsNextPage),
      managementNextPage: mapFields(data?.managementNextPage),
    };
    resolve(fields); 
  } catch (error) {
    console.error("Error accessing drilldown data:", error);
    reject(error); 
  }
});

export { fields, fieldsReady };
